// @flow

import type {TreeRowData} from '../typedef';


export const prepareTreeView = <DataRow = {||}>(treeView: Array<TreeRowData<DataRow>>): Array<TreeRowData<DataRow>> => {

    const isTotalChild = (node: TreeRowData<DataRow>): boolean => {
        if (node.children && Array.isArray(node.children)) {
            const treeChildren = ((node.children: any): Array<TreeRowData<DataRow>>);

            return treeChildren.length === 1
                && !!treeChildren[0].isTotal
                && treeChildren[0].expanded === undefined;
        }

        return false;
    };

    return treeView.map(node => {
        const {children, ...preparedNode} = node;
        const childNodes =
            node.expanded !== undefined && children && !isTotalChild(node)
                ? prepareTreeView(((children: any): Array<TreeRowData<DataRow>>))
                : [];

        let nodeObject = {
            ...preparedNode
        };

        if (childNodes.length) {
            nodeObject = {
                ...nodeObject,
                children: childNodes
            };
        }

        return nodeObject;
    });
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
